type Reducer<T> = (previousValue: T[], currentValue: T, currentIndex: number, array: T[]) => T[]
type ReducerInto<U, T> = (previousValue: U, currentValue: T, currentIndex: number, array: T[]) => U

/** @internal */
export function reduceMap<IndexType, ValueType, ReturnType>(
    map: Map<IndexType, ValueType>,
    reducer: ReducerInto<ReturnType, [IndexType, ValueType]>,
    initialReducerValue: ReturnType,
): ReturnType
/** @internal */
export function reduceMap<IndexType, ValueType>(
    map: Map<IndexType, ValueType>,
    reducer: Reducer<[IndexType, ValueType]>,
): Map<IndexType, ValueType>
/** @internal */
export function reduceMap<IndexType, ValueType, ReturnType>(
    map: Map<IndexType, ValueType>,
    reducer: Reducer<[IndexType, ValueType]>,
    initialReducerValue?: [IndexType, ValueType][],
): ReturnType {
    const reducedValue = Array.from(map.entries()).reduce(reducer, initialReducerValue ?? [])
    if (initialReducerValue !== undefined && typeof map !== typeof initialReducerValue) {
        return reducedValue as ReturnType
    }
    return new Map(reducedValue) as ReturnType
}
